export enum BetPlacementErrorIcon {
    Warning,
    Error,
}
